import PaginationConfig from "../entities/PaginationConfig";
import DefaultCollectionQuery from "@/entities/DefaultCollectionQuery";

const paginationConfig: PaginationConfig = {
  page: 1,
  total: 0,
  limit: 50,
  loadedCount: 50,
};

const defaultCollectionQuery: DefaultCollectionQuery = {
  page: String(paginationConfig.page),
  limit: String(paginationConfig.limit),
};

export {
  defaultCollectionQuery,
};

export default paginationConfig;
